export default __webpack_public_path__ + "static/media/insta.e6cd0266.svg";